export function renderParagraph(text: string, containerDiv: HTMLDivElement): HTMLDivElement {
  const para: HTMLElement = document.createElement("p");
  const node: Node = document.createTextNode(text);
  para.appendChild(node);
  containerDiv.append(para);

  return containerDiv;
}

export function renderImage(file: string, description: string, containerDiv: HTMLDivElement): HTMLDivElement {
  const image = document.createElement("img");
  image.alt = (description !== undefined ? description : "");
  image.src = require("@/client/assets/" + file);
  containerDiv.appendChild(image);

  return containerDiv;
}